import { z } from "zod";

export const verifyEmailSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, "Email is required")
    .email("Enter a valid email address"),
});

export const verifyOtpSchema = z.object({
  otp: z
    .string()
    .transform((s) => s.replace(/\D/g, ""))
    .pipe(z.string().regex(/^\d{6}$/, "Enter the 6-digit verification code")),
});

export const generateOtpResponseSchema = z.object({
  expireAt: z.string(),
});

export type VerifyEmailValues = z.infer<typeof verifyEmailSchema>;
export type VerifyOtpValues = z.infer<typeof verifyOtpSchema>;
export type GenerateOtpResponse = z.infer<typeof generateOtpResponseSchema>;
